<template>
  <div class="login"></div>
</template>
<script>
import { login } from "@/api/login";
import { testLogin } from "@/api/test";
export default {
  name: "ssoLogin",
  data() {
    return {
      loading: false,
      username: "",
      password: "",
      langSelected: localStorage.getItem("lang") || "zh-TW",
      type: true,
      studentType: "",
      isUat: JSON.parse(localStorage.getItem("$myconfig")).isUat
    };
  },
  components: {},
  methods: {
    isPhone() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.isMobile = flag === null;
      this.$store.commit("Config/set_device", this.isMobile);
      return flag;
    },
    async login() {
      this.$store.commit("Config/set_studentType", this.studentType);
      this.loading = true;
      console.log(this.studentType);
      try {
        if (this.studentType === "new") {
          // 进行新旧生登录

          this.loading = false;
        } else if (this.studentType === "old") {
          // 进行新旧生登录
          this.$store.commit("Config/set_applicationId", "");
          const { data } = await testLogin({
            ApplicationCode: this.username
          });
          // console.log(data);
          this.$store.commit("Config/set_applicationId", data);
          this.loading = false;
          this.success();
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
      }
    },
    success() {
      if (this.studentType === "new") {
        this.$router.push({
          path: "/newStu"
        });
        return;
      }
      this.$router.push({
        path: "/oldStu"
      });
    },
    getLanguage() {
      this.$i18n.locale = this.langSelected;
      localStorage.setItem("lang", this.langSelected);
    },
  },
  async mounted() {
    let urlPames = this.$route.query;
    console.log(urlPames.Type)
    console.log(urlPames);
    this.studentType =
      urlPames.Type == "new_student"
        ? "nuew"
        : urlPames.Type == "old_student"
        ? "old"
        : "";
    this.username = urlPames.Account;

    if(!this.username){
      return this.$router.push({
        path: "/",
      });
    }
    await this.login()
  },
  watch: {},
  computed: {
    language() {
      return [
        {
          id: "zh-TW",
          name: this.$t("app.zhTW"),
        },
        {
          id: "en",
          name: this.$t("app.en"),
        },
      ];
    },
  },
};
</script>
<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100%;
  background: url("../../../assets/login/login.jpg") center no-repeat;
  background-size: 100% 100%;
}
</style>
